'use client';

import { Tooltip } from '@wk/wk-uni-lib';
import { useAtomValue } from 'jotai';
import Image from 'next/image';
import { useEffect, useState } from 'react';

import { updateVersionState } from '@/api/common';
import { useTraceCommonParams } from '@/hooks/use-trace-common-params';
import { commonLanguageAtom } from '@/store/language-store';
import { accountAtom } from '@/store/user-store';
import { switchVersion } from '@/utils/url';

import SwitchVersionHint from './switch-version-hint';

export default function SwitchVersionButton() {
  const translateData = useAtomValue(commonLanguageAtom);
  const account = useAtomValue(accountAtom)?.content;
  const [showSwitchVersionHint, setShowSwitchVersionHint] = useState(false);
  const { traceWithCommonParams } = useTraceCommonParams();

  useEffect(() => {
    const { WEB_FLOAT_NOTICE, NOTICE_USER_TYPE } =
      account?.accountData?.webEventNotice || {};
    if (WEB_FLOAT_NOTICE && NOTICE_USER_TYPE === 'OLD') {
      setShowSwitchVersionHint(true);
    }
  }, [account]);

  const handleToOldVersion = async () => {
    traceWithCommonParams({
      _event: 'C_VersionChange',
    });

    if (showSwitchVersionHint) {
      setShowSwitchVersionHint(false);
    }

    await updateVersionState({
      events: [
        { type: 'WEB_FLOAT_NOTICE' },
        { type: 'WEB_VERSION_CHOICE', choice: 'OLD' },
      ],
    });
    switchVersion();
  };

  return (
    <>
      <Tooltip title={translateData['版本切换-按钮-hover信息']}>
        <button
          className="relative flex cursor-pointer items-center justify-center rounded-lg border-[1px] border-border-light bg-bg-card_gray_light p-1.5"
          onClick={handleToOldVersion}>
          <Image
            width={24}
            height={24}
            src="/images/common/switch.png"
            alt="Wukong"
            className="h-6 w-6"
          />
        </button>
      </Tooltip>
      <SwitchVersionHint
        visible={showSwitchVersionHint}
        setVisible={setShowSwitchVersionHint}
      />
    </>
  );
}
